import { useEffect } from 'react';
import { useSdk, useSuspenseQuery } from '../api/hooks.js';
import { GameSessionSuite } from './GameSessionSuite.js';
import { HotseatGameSuite } from './HotseatGameSuite.js';
export function useCreateGameSuite(gameSessionId, gameModules, hotseat) {
    const sdk = useSdk();
    const { data: gameSuite } = useSuspenseQuery({
        queryFn: () => {
            if (hotseat) {
                return HotseatGameSuite.load(gameSessionId, gameModules);
            }
            return GameSessionSuite.load(gameSessionId, gameModules, sdk);
        },
        queryKey: ['gameSession', gameSessionId],
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        refetchInterval: false,
        staleTime: Infinity,
    });
    useEffect(() => gameSuite.connect(), [gameSuite]);
    // for debugging
    window.gameSuite = gameSuite;
    return gameSuite;
}
//# sourceMappingURL=useCreateGameSuite.js.map